import { useEffect, useRef } from 'react'

export default function useFirstMountEffect(effect: () => void) {
  const hookStateRef = useRef<{ effect: () => void; done: boolean }>()
  if (!hookStateRef.current) {
    hookStateRef.current = { effect, done: false }
  }
  hookStateRef.current.effect = effect

  useEffect(() => {
    if (!hookStateRef.current.done) {
      hookStateRef.current.effect?.()
      hookStateRef.current.done = true
    }
  }, [])
}
